import { useRouter } from 'next/router'
import React from 'react'

import { logger } from '@portal/logger'

import { useI18n } from '@/shared/lib/i18n'
import { getPreferredLanguage, getRouterLanguage } from '@/shared/lib/language'

export function useLanguageRedirectPortal() {
    const router = useRouter()
    const { lang } = useI18n()

    // biome-ignore lint/correctness/useExhaustiveDependencies: ?
    React.useEffect(() => {
        if (!router.isReady) {
            return
        }

        const preferredLang = getPreferredLanguage()
        const routerLang = getRouterLanguage(router)

        if (!routerLang) {
            logger.info('No language specified in query or path, falling back to default language')
            void router.replace(`/${preferredLang ?? lang}${router.asPath}`)
            return
        }

        if (preferredLang && preferredLang !== routerLang) {
            void router.replace(`/${preferredLang}${router.asPath.slice(3)}`)
        }
    }, [router])
}
